import { render, staticRenderFns } from "./ConfirmChangeEmail.vue?vue&type=template&id=3a18c5de"
import script from "./ConfirmChangeEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmChangeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports